module.exports = __webpack_public_path__ + "img/cybersecurity-vulnerability.25944e57.png";